<template>
  <el-row>
    <el-card shadow="none"
             class="form-card mb-15">
      <el-form :inline="true"
               :model="searchForm"
               ref="search_form"
               class="search-form">
        <el-form-item label="ClientID:"
                      prop="code">
          <el-input v-model.trim="searchForm.code"
                    placeholder="ClientID"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     @click="searchSubmit('search_form')">查询
          </el-button>
          <el-button icon="el-icon-refresh"
                     @click="resetForm('search_form')">重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-row>
      <el-button type="primary"
                 @click="multipleAct">批量激活</el-button>
    </el-row>
    <el-card shadow="none"
             class="mt-15">
      <el-table max-height="575"
                ref="multipleTable"
                :data="tableData"
                @selection-change="handleSelectionChange">
        <el-table-column type="selection"
                         width="80"> </el-table-column>
        <el-table-column v-for="(item, index) in tableTitle"
                         :fixed="item.fixed"
                         :key="index"
                         :label="item.name"
                         :prop="item.prop"
                         :min-width="item.width"
                         :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <template v-if="item.prop === 'status'">
              <el-tag v-if="scope.row[item.prop] === 0"
                      type="danger">
                off
              </el-tag>
              <el-tag v-else
                      type="success">
                on
              </el-tag>
            </template>
            <el-progress v-else-if="item.prop === 'power'"
                         :text-inside="true"
                         :stroke-width="15"
                         :percentage="scope.row[item.prop]"
                         :color="customColors"></el-progress>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="150">
          <template slot-scope="scope">
            <el-button plain
                       size="mini"
                       type="primary"
                       @click="handleDetail(scope.row)">详情</el-button>
            <el-button plain
                       size="mini"
                       type="success"
                       @click="handleDelete(scope.row)">激活</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagination :total="pagination.total"
                  :pageSize="pagination.perPage"
                  @handleSizeChange="handleSizeChange"
                  @handleCurrent="handleCurrentChange"></Pagination>
    </el-card>
    <act-detail :isShow="showDetailModal"
                :data="detailID"
                @handleClose="closeDetailModal"></act-detail>
  </el-row>
</template>

<script>
import ActDetail from '@/views/device/gatewayAct/ActDetail'
import Pagination from '@/components/pagination/Pagination'
export default {
  components: { ActDetail, Pagination },
  data() {
    return {
      searchForm: {
        code: ''
      },
      tableTitle: [
        {
          prop: 'code',
          name: 'ClientID',
          width: '100'
        },
        {
          prop: 'type',
          name: '订阅主题',
          width: '80'
        },
        {
          prop: 'status',
          name: '在线',
          width: '80'
        },
        {
          prop: 'time',
          name: '上线时间',
          width: '120'
        }
      ],
      tableData: [
        {
          code: '1001',
          type: '网关',
          status: 1,
          time: '2020-09-09 08:00:12'
        },
        {
          code: '1002',
          type: '网关',
          status: 0,
          time: '2020-09-09 08:00:12'
        },
        {
          code: '1003',
          type: '网关',
          status: 1,
          time: '2020-09-09 08:00:12'
        }
      ],
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 10
      },
      // 选中数据
      multipleSelection: [],
      // 详情相关
      showDetailModal: false,
      detailID: -1,
      // 定义进度条颜色
      customColors: [
        { color: '#f56c6c', percentage: 20 },
        { color: '#e6a23c', percentage: 40 },
        { color: '#5cb87a', percentage: 60 },
        { color: '#1989fa', percentage: 80 },
        { color: '#67c23a', percentage: 100 }
      ]
    }
  },
  methods: {
    // 获取列表
    getList() {
      // let start = (this.pagination.currentPage - 1) * this.pagination.perPage
      // fetch
      //   .getStaffList({
      //     start: start,
      //     limit: this.pagination.perPage,
      //     ...this.searchForm
      //   })
      //   .then((data) => {
      //     data.procData(
      //       data.res,
      //       (data) => {
      //         this.pagination.total = data.count
      //         this.tableData = data.result
      //       },
      //       (err) => {
      //         this.$message.error(err)
      //       }
      //     )
      //   })
    },
    // 搜索提交
    searchSubmit() {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.getList()
    },
    resetForm(formName) {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.$refs[formName].resetFields()
      this.getList()
    },
    // 选择变化
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 分页
    handleSizeChange(val) {
      this.pagination.perPage = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    // 批量激活
    multipleAct() {
      if (this.multipleSelection.length > 0) {
        this.$confirm('是否确定激活选中的数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let selectIds = this.multipleSelection
              .map((item) => {
                return item.id
              })
              .join(',')
            console.log(selectIds)
          })
          .catch(() => {})
      } else {
        this.$message.warning('请选择需要激活的网关后重试')
      }
    },
    // 详情
    handleDetail(data) {
      this.showDetailModal = true
      this.detailID = data.id
    },
    closeDetailModal() {
      this.showDetailModal = false
    },
    // 激活
    handleDelete(data) {
      this.$confirm('是否确定激活该网关?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          console.log(data.id)
        })
        .catch(() => {})
    }
  }
}
</script>

<style></style>
